import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import Lang from "../../userPreferences/staticWords";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import { styleEnd, styleStart } from "../../algorithms/styleDirection";
import DateInput from "../sharedComponents/datesInputs/date";
import Button from "../sharedComponents/buttons/button";
import { useDispatch, useSelector } from "react-redux";
import {
  addLinkAPI,
  updateLinkAPI,
} from "../../API/store/actions/agendaAndLinks";
const LinksForm = (props) => {
  const { show, setShow, isEdit, onSuccess } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [siteUrl, setSiteUrl] = useState("");
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login.userData);
  const token = useSelector((state) => state.login.userToken);
  const selectedLink = useSelector((state) => state.links.selectedLink);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (!show) return;

    if (isEdit && selectedLink) {
      setSiteName(selectedLink.data.name || "");
      setSiteUrl(selectedLink.data.url || "");
    }

    if (!isEdit) {
      setSiteName("");
      setSiteUrl("");
    }
  }, [show, isEdit, selectedLink]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};

    if (!siteName.trim()) {
      validationErrors.siteName = Lang.required;
    }

    if (!siteUrl.trim()) {
      validationErrors.siteUrl = Lang.required;
    }

    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setIsSubmitting(true);

    const formData = new FormData();

    if (isEdit) {
      formData.append("Id", selectedLink?.data?.id);
      formData.append("ModifierId", user.id);
    } else {
      formData.append("OwnerId", user.id);
    }

    formData.append("Name", siteName);
    formData.append("Url", siteUrl);
    formData.append("Active", true);

    try {
      const action = isEdit
        ? await updateLinkAPI(formData, token)
        : await addLinkAPI(formData, token);

      dispatch(action);
      await onSuccess?.();
      setShow(false);
      setSiteName("");
      setSiteUrl("");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "white",
                height: 25,
                width: 30,
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center px-1 mt-1"
            >
              <img
                src={"/assets/images/icons/links.png"}
                width={25}
                height={25}
                alt=""
              />
            </div>

            <div className="text-dark">
              <p
                className="my-0 mx-1"
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "rgb(12, 87, 76)",
                }}
              >
                {isEdit ? Lang.editLink : Lang.createLink}
              </p>
            </div>
          </div>
        </Modal.Title>

        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"rgb(12, 87, 76)"}
            onclick={() => setShow(false)}
          />
        </div>
      </Modal.Header>

      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">{Lang.siteName}</label>{" "}
              <input
                type="text"
                className="form-control"
                value={siteName}
                onChange={(e) => {
                  setSiteName(e.target.value);
                  setErrors((prev) => ({ ...prev, siteName: "" }));
                }}
                placeholder={Lang.enterSiteName}
              />
              {errors.siteName && (
                <div className="invalid-feedback d-block">
                  {errors.siteName}
                </div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">{Lang.siteUrl}</label>{" "}
              <input
                type="url"
                className="form-control"
                value={siteUrl}
                onChange={(e) => {
                  setSiteUrl(e.target.value);
                  setErrors((prev) => ({ ...prev, siteUrl: "" }));
                }}
                placeholder="https://example.com"
              />
              {errors.siteUrl && (
                <div className="invalid-feedback d-block">{errors.siteUrl}</div>
              )}
            </div>
          </div>

          <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
            <Button
              type={"submit"}
              disable={isSubmitting}
              content={isSubmitting ? Lang.isSaving : Lang.save}
              containerStyle="col-2 mx-3"
              buttonStyleType={"solid"}
            />
            <Button
              type={"button"}
              onClick={() => setShow(false)}
              content={Lang.cancel}
              containerStyle="col-2 mx-3"
            />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default LinksForm;
